module.exports = __webpack_public_path__ + "img/sh.d7b2c0ae.png";